import styled from "styled-components";

export const HomeOptionsWrapper = styled.div`
  width: 100%;
  background: white;
  min-height: 100vh;
`;

export const OptionsSelector = styled.div`
  cursor: pointer;
  width: 100%;
  background: white;
  border-bottom: 1px solid lightgray;
  padding-left: 10px;
  padding-top: 15px;
  display: flex;
`;

export const IrisSelectionItem = styled.div`
  img {
    border: ${props => props.active ? '3px solid #53b6ba': 'none'};
  }
`;

export const EffectSelectionItem = styled.div`
  display: flex;
  margin-bottom: 10px;


  img {
    border: ${props => props.active ? '3px solid #53b6ba': 'none'};
  }
`;

export const IrisBadge = styled.div`
  background: #53b6ba;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  text-align: center;
  font-size: 12px;
  margin-left: 10px;
`;

export const BasketItem = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
`;

export const MobileWrapper = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

export const CommonSelectorContainer = styled.div`
  margin: 10px;
  background: black;
  width: 150px;
  text-align: center;
  padding-top: 5px;
  box-shadow: 0 0 5px grey;
  border-radius: 10px;
`;